
// 获取url参数
export const getQueryString = function (name) { 
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); 
    let url = window.location.search; //获取url中"#"符后的字串  
    console.log(url)
    let r = url.substr(1).match(reg); 
    if (r != null) return unescape(r[2]); 
    return null; 
} 

// 获取url参数
export const getRequest = function (name) { 
    let url = location.search; //获取url中"?"符后的字串  
    let theRequest = new Object();  
    if (url.indexOf("?") != -1) {  
       let str = url.substr(1);  
       let strs = str.split("&");  
       for(let i = 0; i < strs.length; i ++) {  
          theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);  
       }  
    }  
    return theRequest;  
} 

//url编码
export const urlencode = function (data) {
  let str = "";
  Object.keys(data).map(item => {
    str += "&" + item + "=" + data[item];
  });
  const params = "?" + str.slice(1);
  return params;
}

//判断UA
export const JudgeUA = function () {
    const ua = navigator.userAgent.toLowerCase();
    if (ua != null && ua.includes('micromessenger')) return 'wechat';
    if (ua != null && ua.includes('alipay')) return 'alipay';
    if (ua != null && ua.includes('jdapp')) return 'jdapp';
    if (ua != null && ua.includes('jdjr')) return 'jdjr';
    if (ua != null && ua.includes('mpbank')) return 'cmb';
    return "other";
}

//判断当前扫码环境
export const scanApp = function () {
    const UA = JudgeUA();
    switch (UA) {
      case 'wechat':
        return 'A';
      case 'alipay':
        return 'B';
      // case 'wechat':
      //   return 'C';
      // case 'alipay':
      //   return 'D';
      case 'jdapp':
        return 'E';
      case 'jdjr':
        return 'F';
      case 'cmb':
        return 'M';
      default:
        return 'other';
    }
}

export const setHistoryCars = function (car) {
    let historyCars = localStorage.getItem('historyCars')
    if(historyCars){
        let carArr = historyCars.split(",")
        if(carArr.includes(car)){ 
            let carIndex = carArr.indexOf(car)
            carArr.splice(carIndex, 1)
        }
        carArr.unshift(car)
        localStorage.setItem('historyCars', carArr)
    }else{
        let historyCarsArr = new Array(car)
        console.log(historyCarsArr)
        console.log(typeof historyCarsArr)
        localStorage.setItem('historyCars', historyCarsArr)
    }
}

export const delHistoryCars = function (car) {
    let historyCars = localStorage.getItem('historyCars')
    let carArr = historyCars.split(",")
    let carIndex = carArr.indexOf(car)
    carArr.splice(carIndex, 1)
    localStorage.setItem('historyCars', carArr)
}

export const setMerchantHistoryCars = function (car) {
  let historyCars = localStorage.getItem('merchantHistoryCars')
  if(historyCars){
      let carArr = historyCars.split(",")
      if(carArr.includes(car)){ 
          let carIndex = carArr.indexOf(car)
          carArr.splice(carIndex, 1)
      }
      carArr.unshift(car)
      localStorage.setItem('merchantHistoryCars', carArr)
  }else{
      let historyCarsArr = new Array(car)
      console.log(historyCarsArr)
      console.log(typeof historyCarsArr)
      localStorage.setItem('merchantHistoryCars', historyCarsArr)
  }
}

// 删除本地历史车辆
export const delMerchantHistoryCars = function (car) {
  let historyCars = localStorage.getItem('merchantHistoryCars')
  let carArr = historyCars.split(",")
  let carIndex = carArr.indexOf(car)
  carArr.splice(carIndex, 1)
  localStorage.setItem('merchantHistoryCars', carArr)
}

// 获取当前日期、时间
export const currentDate = function () {
  let date = new Date()
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let seconds = date.getSeconds()
  return {year, month, day, hours, minutes, seconds}
}
// 获取下个月、上个月份
export const monthObj = function (currentMonth) {
  if(currentMonth.length != 7 || currentMonth.indexOf('-') == -1){
    alert('参数错误')
    return
  }
  let currYear = parseInt(currentMonth.substr(0, 4))
  let currMonth = parseInt(currentMonth.substr(5, 2))
  let lastYear = ''
  let lastMonth = ''
  let nextYear = ''
  let nextMonth = ''

  if(currMonth == 1){
    lastYear = currYear - 1
    lastMonth = 12
    nextYear = currYear
    nextMonth = 2
  }else if(currMonth == 12){
    lastYear = currYear
    lastMonth = 11
    nextYear = currYear + 1
    nextMonth = 1
  }else{
    lastYear = currYear
    lastMonth = currMonth - 1
    nextYear = currYear
    nextMonth = currMonth + 1
  }
  let last = lastYear + '-' + (lastMonth < 10 ? '0'+lastMonth : lastMonth)
  let next = nextYear + '-' + (nextMonth < 10 ? '0'+nextMonth : nextMonth)

  return {last, next}
}

//返回车牌颜色
const carColor = function (value) {
    if (value == '1') return '蓝牌 ';
    if (value == '2') return '黄牌 ';
    if (value == '3') return '白牌 ';
    if (value == '4') return '黑牌 ';
    if (value == '5') return '绿牌 ';
    return '';
  }
  //返回车辆类型
  const carType = function (value) {
    if (value == '1') return '小型汽车，';
    if (value == '2') return '中型汽车，';
    if (value == '3') return '大型汽车，';
    if (value == '4') return '其他汽车，';
    return '';
  }
  //拼接计费规则
  export const chargeRule = function (data) {
    let feeStr = "";
    let feeArr = [];
    data.map(item => {
      let timeType = item.timeType == 0 ? "小时" : "分钟";
      if (item.valuationType == "0") {
        feeStr =
          "统一计费：" +
          carColor(item.licenseColor) +
          carType(item.carType) +
          "免费时间" +
          item.freeTime +
          "分钟，起步价" +
          item.firstTime +
          timeType +
          "/" +
          item.firstPrice +
          "元，后续每" +
          item.afterTime +
          timeType +
          "/" +
          item.afterPrice +
          "元。";
        feeArr.push(feeStr);
      } else if (item.valuationType == "1") {
        feeStr =
          "分段计费：" +
          carColor(item.licenseColor) +
          carType(item.carType) +
          "白天：起步价" +
          item.dayFirstTime +
          timeType +
          "/" +
          item.dayFirstPrice +
          "元，后续每" +
          item.dayAfterTime +
          timeType +
          "/" +
          item.dayAfterPrice +
          "元。" +
          "晚上：起步价" +
          item.nightFirstTime +
          timeType +
          "/" +
          item.nightFirstPrice +
          "元，后续每" +
          item.nightAfterTime +
          timeType +
          "/" +
          item.nightAfterPrice +
          "元。";
        feeArr.push(feeStr);
      } else if (item.valuationType == "2") {
        feeStr =
          "按次计费：" +
          carColor(item.licenseColor) +
          carType(item.carType) +
          "免费时间" +
          item.freeTime +
          "分钟，单次停车" +
          item.loopHour +
          timeType +
          "内，收费" +
          item.firstPrice +
          "元，超出时间重新计费。";
        feeArr.push(feeStr);
      }
    });
    return feeArr;
  }

//将倒计时秒数转换为时间字符串
export const formatCountDownTime = function (second) {
    const s = parseInt(second);
    const min = Math.floor(s / 60) < 10 ? ('0' + Math.floor(s / 60).toString()) : (Math.floor(s / 60).toString());
    const sec = (s % 60) < 10 ? ('0' + (s % 60).toString()) : ((s % 60).toString());
    return min + ':' + sec;
}

//关闭页面
export const closeWebviewEvent = function (e) {
  const scanApp = JudgeUA();
  if (window.WeixinJSBridge) {
    window.WeixinJSBridge.call("closeWindow");
  }

  if (window.AlipayJSBridge) {
    window.AlipayJSBridge.call("closeWebview");
  }

  if (scanApp == "jdapp") {
    JSSDK.WebView.closeActiveWebview();
  }

  if (scanApp == "jdjr") {
    JrBridge.closeView();
  }

  if (scanApp == "cmb") {
    if (system() == "android") {
      window.open("http://cmbandroid/tool", "_top", "");
    } else if (system() == "ios") {
      window.open("http://cmbiphone/tool", "_top", "");
    }
  }
}

//随机车牌号
export const randomCarlicense = function () {
  var $chars = '0123456789ABCDEFGHJKLMNPQRSTUVWXYZ';
  var maxPos = $chars.length;
  var pwd = '';
  for (let i = 0; i < 6; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return '临' + pwd;
}

//随机字符串
export const uuid = function (len) {
  var $chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var maxPos = $chars.length;
  var pwd = '';
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

export const toLocale= function (date) {
  // 补0   例如 2018/7/10 14:7:2  补完后为 2018/07/10 14:07:02
  function addZero(num) {
    if (num < 10)
      return "0" + num;
    return num;
  }
  // 按自定义拼接格式返回
  return date.getFullYear() + "/" + addZero(date.getMonth() + 1) + "/" + addZero(date.getDate()) + " " +
    addZero(date.getHours()) + ":" + addZero(date.getMinutes()) + ":" + addZero(date.getSeconds());
};
export const setTimes = function (timer) {
  var time = new Date(timer);
  // window.console.log(time)
  // var date = new Date(timer);
  // 按重写的自定义格式，格式化日期
  return toLocale(time)
}

export const carlicensePrefix = function (code) {
  let $data = {'1301':"冀A",'1302':"冀B",'1303':"冀C",'1304':"冀D",'1305':"冀E",'1306':"冀F",'1307':"冀G",'1308':"冀H",'1309':"冀J",'1310':"冀R",'1311':"冀T",'2101':"辽A",'2102':"辽B",'2103':"辽C",'2104':"辽D",'2105':"辽E",'2106':"辽F",'2107':"辽G",'2108':"辽H",'2109':"辽J",'2110':"辽K",'2111':"辽L",'2112':"辽M",'2113':"辽N",'2114':"辽P",'3401':"皖A",'3402':"皖B",'3403':"皖C",'3404':"皖D",'3405':"皖E",'3406':"皖F",'3407':"皖G",'3408':"皖H",'3410':"皖J",'3412':"皖K",'3413':"皖L",'3411':"皖M",'3415':"皖N",'3418':"皖P",'3417':"皖R",'3416':"皖S",'3201':"苏A",'3202':"苏B",'3203':"苏C",'3204':"苏D",'3205':"苏E",'3206':"苏F",'3207':"苏G",'3208':"苏H",'3209':"苏J",'3210':"苏K",'3211':"苏L",'3212':"苏M",'3213':"苏N",'4201':"鄂A",'4202':"鄂B",'4203':"鄂C",'4210':"鄂D",'4205':"鄂E",'4206':"鄂F",'4207':"鄂G",'4208':"鄂H",'4211':"鄂J",'4209':"鄂K",'4212':"鄂L",'4290':"鄂M",'4228':"鄂Q",'4213':"鄂S",'1401':"晋A",'1402':"晋B",'1403':"晋C",'1404':"晋D",'1405':"晋E",'1406':"晋F",'1409':"晋H",'1411':"晋J",'1407':"晋K",'1410':"晋L",'1408':"晋M",'2201':"吉A",'2202':"吉B",'2203':"吉C",'2204':"吉D",'2205':"吉E",'2206':"吉F",'2208':"吉G",'2224':"吉H",'2207':"吉J",'4401':"粤A",'4403':"粤B",'4404':"粤C",'4405':"粤D",'4406':"粤E",'4402':"粤F",'4408':"粤G",'4412':"粤H",'4407':"粤J",'4409':"粤K",'4413':"粤L",'4414':"粤M",'4415':"粤N",'4416':"粤P",'4417':"粤Q",'4418':"粤R",'4419':"粤S",'4420':"粤T",'4451':"粤U",'4452':"粤V",'4453':"粤W",'4101':"豫A",'4102':"豫B",'4103':"豫C",'4104':"豫D",'4105':"豫E",'4106':"豫F",'4107':"豫G",'4108':"豫H",'4109':"豫J",'4110':"豫K",'4111':"豫L",'4112':"豫M",'4114':"豫N",'4116':"豫P",'4117':"豫Q",'4113':"豫R",'4115':"豫S",'4190':"豫U",'2301':"黑A",'2302':"黑B",'2310':"黑C",'2308':"黑D",'2306':"黑E",'2307':"黑F",'2303':"黑G",'2304':"黑H",'2305':"黑J",'2309':"黑K",'2311':"黑N",'2327':"黑P",'3701':"鲁A",'3702':"鲁B",'3703':"鲁C",'3704':"鲁D",'3705':"鲁E",'3706':"鲁F",'3707':"鲁G",'3708':"鲁H",'3709':"鲁J",'3710':"鲁K",'3711':"鲁L",'3716':"鲁M",'3714':"鲁N",'3715':"鲁P",'3713':"鲁Q",'3717':"鲁R",'3712':"鲁S",'3301':"浙A",'3302':"浙B",'3303':"浙C",'3306':"浙D",'3305':"浙E",'3304':"浙F",'3307':"浙G",'3308':"浙H",'3310':"浙J",'3311':"浙K",'3309':"浙L",'4501':"桂A",'4502':"桂B",'4503':"桂C",'4504':"桂D",'4505':"桂E",'4514':"桂F",'4513':"桂G",'4511':"桂J",'4509':"桂K",'4510':"桂L",'4512':"桂M",'4507':"桂N",'4506':"桂P",'4508':"桂R",'1501':"蒙A",'1502':"蒙B",'1503':"蒙C",'1504':"蒙D",'1507':"蒙E",'1522':"蒙F",'1505':"蒙G",'1525':"蒙H",'1509':"蒙J",'1506':"蒙K",'1508':"蒙L",'1529':"蒙M",'3501':"闽A",'3503':"闽B",'3505':"闽C",'3502':"闽D",'3506':"闽E",'3508':"闽F",'3504':"闽G",'3507':"闽H",'3509':"闽J",'5101':"川A",'5107':"川B",'5103':"川C",'5104':"川D",'5105':"川E",'5106':"川F",'5108':"川H",'5109':"川J",'5110':"川K",'5120':"川M",'5115':"川Q",'5113':"川R",'5117':"川S",'5180':"川T",'5132':"川U",'5133':"川V",'5134':"川W",'5116':"川X",'5119':"川Y",'5114':"川Z",'5301':"云A",'5306':"云C",'5303':"云D",'5323':"云E",'5304':"云F",'5325':"云G",'5326':"云H",'5308':"云J",'5328':"云K",'5329':"云L",'5305':"云M",'5331':"云N",'5307':"云P",'5333':"云Q",'5334':"云R",'5309':"云S",'4301':"湘A",'4302':"湘B",'4303':"湘C",'4304':"湘D",'4305':"湘E",'4306':"湘F",'4308':"湘G",'4309':"湘H",'4307':"湘J",'4313':"湘K",'4310':"湘L",'4311':"湘M",'4312':"湘N",'4331':"湘U",'6501':"新A",'6523':"新B",'6590':"新C",'6540':"新D",'6527':"新E",'6540':"新F",'6542':"新G",'6543':"新H",'6502':"新J",'6521':"新K",'6522':"新L",'6528':"新M",'6529':"新N",'6530':"新P",'6531':"新Q",'6532':"新R",'6590':"新N",'3601':"赣A",'3607':"赣B",'3609':"赣C",'3608':"赣D",'3611':"赣E",'3610':"赣F",'3604':"赣G",'3602':"赣H",'3603':"赣J",'3605':"赣K",'3606':"赣L",'6201':"甘A",'6202':"甘B",'6203':"甘C",'6204':"甘D",'6205':"甘E",'6209':"甘F",'6207':"甘G",'6206':"甘H",'6211':"甘J",'6212':"甘K",'6208':"甘L",'6210':"甘M",'6229':"甘N",'6230':"甘P",'6101':"陕A",'6102':"陕B",'6103':"陕C",'6104':"陕D",'6105':"陕E",'6107':"陕F",'6109':"陕G",'6110':"陕H",'6106':"陕J",'6108':"陕K",'5201':"贵A",'5202':"贵B",'5203':"贵C",'5206':"贵D",'5223':"贵E",'5205':"贵F",'5204':"贵G",'5226':"贵H",'5227':"贵J",'6301':"青A",'6321':"青B",'6322':"青C",'6323':"青D",'6325':"青E",'6326':"青F",'6327':"青G",'6328':"青H",'5401':"藏A",'5421':"藏B",'5422':"藏C",'5423':"藏D",'5424':"藏E",'5425':"藏F",'5426':"藏G",'4601':"琼A",'4602':"琼B",'4690':"琼C",'4600':"琼E",'6401':"宁A",'6402':"宁B",'6403':"宁C",'6404':"宁D",'6405':"宁E",'5001':"渝A",'5002':"渝C",'1100':"京A",'1200':"津A",'3100':"沪A"}
  let $province = ''
  let $city = ''
  for (const key in $data) {
    if(code == key){
      $province = $data[key].substr(0, 1)
      $city = $data[key].substr(1, 1)
    }
  }
  return {province: $province, city: $city}
}